<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
              ref="formselect"
              :model="formselect"
              label-width="160px"
              class="queryform_div"
          >
            <el-row :gutter="24">
            <el-col :md="8" :xs="24" :sm="24">
              <el-form-item :label="$t('station.projectName')">
                <el-input
                    v-model="formselect.ProjectName"
                    style="width: 100%"
                    size="small"
                ></el-input>
              </el-form-item>
            </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('station.industryName')">
                  <el-input
                      v-model="formselect.IndustryName"
                      style="width: 100%"
                      size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('station.region')">
                  <el-input
                      v-model="formselect.Region"
                      style="width: 100%"
                      size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('station.province')">
                  <el-input
                      v-model="formselect.Province"
                      style="width: 100%"
                      size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('station.city')">
                  <el-input
                      v-model="formselect.City"
                      style="width: 100%"
                      size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-button @click="getData" type="primary" size="small" style="margin-top: 10px; margin-left: 110px">{{
                    $t("button.query")
                  }}</el-button>
                <el-button @click="resetKeyword" size="small">{{
                    $t("button.reset")
                  }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
                v-if="hasCreateAuth"
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="showAddDialog(true)"
                style="margin-bottom: 10px"
            >{{ $t("station.addProjectName") }}</el-button
            >
            <div class="tableDiv">
              <el-table
                  :data="tableData1"
                  ref="tableData1"
                  stripe
                  v-loading="loading"
                  class="formSTable NoRaidoLabel"
                  :empty-text="$t('desc.noData')"
                  :height="VersionTHeight"
              >
                <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('station.projectName')"
                    min-width="30%"
                    prop="projectName"
                >
                </el-table-column>
                  <el-table-column
                      :label="$t('station.projectNameEn')"
                      min-width="30%"
                      prop="projectNameEn"
                  >
                </el-table-column>
                <el-table-column
                    :label="$t('station.industryName')"
                    prop="industryName"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('station.region')"
                    prop="region"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('station.province')"
                    prop="province"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('station.city')"
                    prop="city"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('station.originUnitConsump')"
                    prop="originUnitConsump"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('station.electPrice')"
                    prop="electPrice"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('title.creatTime')"
                    prop="createTime"
                    min-width="30%"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('title.operate')"
                    width="220"
                    fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                        v-if="hasUpdateAuth"
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        :title="$t('button.update')"
                        size="mini"
                        @click="edit(scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('button.delete')"
                          :cancelButtonText="$t('button.cancel')"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('title.confirmDelete')"
                          @confirm="delInfo(scope.row.id)"
                      >
                        <el-button
                            v-if="hasDeleteAuth"
                            type="danger"
                            icon="el-icon-delete"
                            :title="$t('button.delete')"
                            circle
                            size="mini"
                            slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pagination.totalPage"
                  :current-page.sync="pagination.current"
                  :page-size="pagination.pageSize"
                  @current-change="getData()"
                  style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>

    <el-dialog
        :title="titleName"
        :visible.sync="dialogAdd"
        width="80%"
        top="5vh"
        @close="cancelsEdit"
        ref="editref"
        style="height: 70%;"
        j
    >
      <el-form ref="formUpdate" :model="formUpdate" label-width="130px">
        <el-row :gutter="24">
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.projectName')"
                prop="projectName"
                :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-input v-model="formUpdate.projectName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.projectNameEn')"
                prop="projectNameEn"
            >
              <el-input v-model="formUpdate.projectNameEn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.industryName')"
                prop="industryName"
            >
              <el-input v-model="formUpdate.industryName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.region')"
                prop="region"
            >
              <el-input v-model="formUpdate.region"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.province')"
                prop="province"
            >
              <el-input v-model="formUpdate.province"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.city')"
                prop="city"
            >
              <el-input v-model="formUpdate.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.originUnitConsump')"
                prop="originUnitConsump"
            >
              <el-input v-model="formUpdate.originUnitConsump"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.electPrice')"
                prop="electPrice"
            >
              <el-input v-model="formUpdate.electPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item
                :label="$t('station.stationImgUrl')"
                prop="stationImgUrl"
            >
              <div class="block">
                <el-image
                    style="width: 50%; height: 100px; margin-top: 20px"
                    :src="formUpdate.stationImgUrl"
                    v-if="formUpdate.stationImgUrl != null && formUpdate.stationImgUrl !== ''"
                    fit="contain"
                >
                </el-image>
              <template  v-if="formUpdate.stationImgUrl != null && formUpdate.stationImgUrl !== ''"
              >
                <el-popconfirm
                    :confirmButtonText="$t('button.delete')"
                    :cancelButtonText="$t('button.cancel')"
                    :title="$t('title.confirmDelete')"
                    @confirm="deleteImage()"
                >
                  <el-button
                      slot="reference"
                      type="danger"
                      circle
                      icon="el-icon-delete"
                      style=""
                  >
                  </el-button>
                </el-popconfirm>
              </template>

              </div>
            <el-button type="primary" @click="importDialog()">上传空压站图片</el-button>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item>
              <el-button type="success" @click="onSubmit">{{
                  $t("button.confirm")
                }}</el-button>
              <el-button @click="cancelsEdit">{{ $t("button.cancel") }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>


    </el-dialog>
    <el-dialog
        title="文件导入"
        :visible.sync="showFileImportDialog"
        width="20%"
        height="70%"
        @close="resetForm"
        ref="fileImportDialog"
        :modal="false"
        class="emc_dialog"
    >
      <el-form ref="importForm" :model="importForm" label-width="80px">
        <el-form-item label="文件名">
          <el-input v-model="importForm.fileName"></el-input>
        </el-form-item>
        <el-form-item label="选择文件">
          <el-upload
              ref="upload"
              action=""
              :on-change="handleFileChange"
              :before-remove="beforeRemove"
              list-type="picture"
              :auto-upload="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancelUpload">取消</el-button>
          <el-button type="primary" @click="submitUpload">上传</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  addStationInfo,
    updateStationInfo,
  getAllStationInfo,
  deleteStationInfo
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import axios from "../../../utils/http";

export default {
  name: "index",
  data() {
    return {
      submitBtn: true,
      checkRes: false,
      titleName: "",
      loading: false,
      autoUpload: false,
      dialogAdd: false,
      dialogmassUpdate: false,
      dialogUpdateResult: false,
      props: { multiple: true },
      VersionTHeight: 500,
      formselect: {
        name: ""
      },
      tableData1: [],
      brandInfo: {},
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      formUpdate: {
        projectName: "",
        industryName: ""
      },
      postData: {},
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      dialogTimeUpgrade: false,
      tableLoading: false,
      UpdateForm: {},
      showFileImportDialog: false,
      importForm: {
        fileName: '',
        fileDescription: '',
        file: null
      }
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  created: function () {
    this.authOperation("emcStation");
  },
  mounted() {
    this.getData();
  },
  methods: {
    deleteImage() {
      this.formUpdate['stationImgUrl'] = "";
    },
    authOperation(curPage) {
      var that = this;
      that.hasCreateAuth = true;
      that.hasUpdateAuth = true;
      that.hasDeleteAuth = true;
      that.hasOtaUpgradeAuth = true;
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    getData() {
      this.loading = true;
      var data = {
        ...this.formselect
      };
      data.SkipCount = (this.pagination.current - 1) * this.pagination.pageSize;
      data.MaxResultCount = this.pagination.pageSize;
      getAllStationInfo(data).then((res) => {
        if (res.success) {
          this.pagination.totalPage = res.result.totalCount;
          this.loading = false;
          this.tableData1 = res.result.items;
        }
      });
    },
    onSubmit() {
      let data = this.formUpdate;
      let formData = data;

      this.$refs["formUpdate"].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            delete data.id;
            addStationInfo(formData)
                .then((res) => {
                  if (res.success) {
                    this.$message.success("success");
                    this.dialogAdd = false;
                    this.fileList = [];
                    this.getData();
                  } else {
                    this.$message.error(res.error.message);
                  }
                })
                .catch((err) => {
                  this.$message.error(err.error.message);
                });
          } else {
            updateStationInfo(formData)
                .then((res) => {
                  if (res.success) {
                    this.$message.success("success");
                    this.dialogAdd = false;
                    this.fileList = [];
                    this.getData();
                  } else {
                    this.$message.error(res.error.message);
                  }
                })
                .catch((err) => {
                  this.$message.error(err.error.message);
                });
          }
        }
      });
    },

    edit(row) {
      this.dialogAdd = true;
      this.dialogType = "edit";
      this.titleName = this.$t("station.edit");
      this.formUpdate = JSON.parse(JSON.stringify(row));
      this.submitBtn = false;
    },

    showAddDialog(visible) {
      this.dialogAdd = visible;
      this.dialogType = "add";
      this.titleName = this.$t("station.create");
    },

    resetKeyword() {
      this.formselect = {
        name: "",
        type: "",
      };
    },
    cancelsEdit() {
      this.dialogAdd = false;
      this.fileList = [];
      this.formUpdate = {};
      this.$refs["formUpdate"].resetFields();
    },
    //删除
    delInfo(e) {
      deleteStationInfo(e).then((res) => {
        if (res.success) {
          this.$message.success(this.$t("tips.deleteSuccess"));
          this.getData();
        }
      });
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
    },

    handleSelectionChange(val) {
      this.gsnList = val.map((x) => x.gsn);
    },

    importDialog() {
      this.showFileImportDialog = true;
      this.$nextTick(() => {
        this.$refs.fileImportDialog.$el.querySelector('input').focus(); // 手动设置焦点
      });
    },
    resetForm() {
      this.importForm = {
        fileName: '',
        fileDescription: '',
        file: null
      };
      this.$refs.upload.clearFiles();
    },
    handleFileChange(file) {
      this.importForm.file = file.raw;
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    cancelUpload() {
      this.showFileImportDialog = false;
      this.resetForm();
    },
    submitUpload() {
      if (!this.importForm.fileName || !this.importForm.file) {
        this.$message.error('请填写文件名并选择文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.importForm.file);
      formData.append('fileName', this.importForm.fileName);
      formData.append('fileDescription', this.importForm.fileDescription);

      axios.post('/api/services/app/StationService/UploadStationImg', formData)
          .then(response => {
            console.log('File uploaded successfully:', response.data);
            this.showFileImportDialog = false;
            this.formUpdate.stationImgUrl = response.data.result;
            this.resetForm();
          })
          .catch(error => {
            console.error('Error uploading file:', error);
            this.resetForm();
          });


      this.showFileImportDialog = false;
      this.resetForm();
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px; /* 添加内边距 */
  z-index: 1; /* 确保在最上层 */
}

::v-deep .emc_dialog .el-dialog {
  margin-top: 20vh !important;
  height: 400px !important;
}


</style>

